/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LifestyleFactorValue } from './LifestyleFactorValue';
import {
    LifestyleFactorValueFromJSON,
    LifestyleFactorValueFromJSONTyped,
    LifestyleFactorValueToJSON,
} from './LifestyleFactorValue';

/**
 * 
 * @export
 * @interface LifestyleFactorHistory
 */
export interface LifestyleFactorHistory {
    /**
     * 
     * @type {number}
     * @memberof LifestyleFactorHistory
     */
    date: number;
    /**
     * 
     * @type {string}
     * @memberof LifestyleFactorHistory
     */
    author_role?: string;
    /**
     * 
     * @type {string}
     * @memberof LifestyleFactorHistory
     */
    author_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LifestyleFactorHistory
     */
    action: string;
    /**
     * 
     * @type {LifestyleFactorValue}
     * @memberof LifestyleFactorHistory
     */
    value: LifestyleFactorValue;
}

/**
 * Check if a given object implements the LifestyleFactorHistory interface.
 */
export function instanceOfLifestyleFactorHistory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function LifestyleFactorHistoryFromJSON(json: any): LifestyleFactorHistory {
    return LifestyleFactorHistoryFromJSONTyped(json, false);
}

export function LifestyleFactorHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LifestyleFactorHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'author_role': !exists(json, 'author_role') ? undefined : json['author_role'],
        'author_id': !exists(json, 'author_id') ? undefined : json['author_id'],
        'action': json['action'],
        'value': LifestyleFactorValueFromJSON(json['value']),
    };
}

export function LifestyleFactorHistoryToJSON(value?: LifestyleFactorHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'author_role': value.author_role,
        'author_id': value.author_id,
        'action': value.action,
        'value': LifestyleFactorValueToJSON(value.value),
    };
}

